@if (bookWidgetFields() && bookWidgetAem()) {
  <div class="modify-book-widget-multi-city-desktop flex flex-col gap-24">
    <div class="flex flex-row justify-between">
      <div class="flex gap-12">
        <idp-select-mach-core
          class="w-[304px]"
          id="trip-type-field"
          [isTitleHidden]="true"
          [title]="bookWidgetAem().tripTypesField.tripTypeAriaLabel"
          [disabled]="bookWidgetFields().tripTypesField.disable"
          [dropdownOptions]="bookWidgetFields().tripTypesField.dropdownOptions"
          (selectionChange)="
            onDropdownSelectionChange(
              $event,
              bookWidgetFieldUpdateTypes.tripType
            )
          "
        ></idp-select-mach-core>
        <idp-select-mach-core
          class="w-[304px]"
          icon="/content/dam/delta-applications/sitewide/capability/flight-shop/images/pax-icon.svg"
          [isTitleHidden]="true"
          [title]="bookWidgetAem().passengerField.passengerAriaLabel"
          [hideDropdownListIcon]="true"
          [disabled]="bookWidgetFields().passengerField.disable"
          [dropdownOptions]="bookWidgetFields().passengerField.dropdownOptions"
          (selectionChange)="
            onDropdownSelectionChange(
              $event,
              bookWidgetFieldUpdateTypes.passenger
            )
          "
        ></idp-select-mach-core>
      </div>
      <button
        id="findFilghtsCta"
        #findFlightButton
        class="button button-primary button-lg"
        tabindex="0"
        data-acdl-name="flights:find flights"
        data-acdl-action="flight search initiation:flights search"
        data-acdl-page-section="header:book:flights"
        (click)="onFindFlightClick(findFlightButton)"
        (keydown.enter)="onFindFlightClick(findFlightButton)"
      >
        {{ bookWidgetAem().searchBtn }}
      </button>
    </div>
    <div class="flex flex-col gap-24">
      @for (
        airportItem of bookWidgetFields().airportsField.airports;
        track i;
        let i = $index
      ) {
        <div class="flex flex-col gap-16">
          <div class="text-label-xs-semibold text-static">
            {{ bookWidgetAem().airportsField.flight }} {{ i + 1 }}
          </div>
          <div class="flex gap-12">
            <idp-multicity-route-picker-mach-core
              class="w-[304px]"
              [routeIndex]="i"
              [routePickerContent]="{
                origin: {
                  title: bookWidgetAem().airportsField.from,
                  subtitle: bookWidgetAem().airportsField.yourOrigin
                },
                destination: {
                  title: bookWidgetAem().airportsField.to,
                  subtitle: bookWidgetAem().airportsField.yourDestination
                },
                ariaLabels: {
                  origin:
                    bookWidgetAem().airportsField.originAriaLabel +
                    (bookWidgetFields().airportsField.airports[i]
                      .fromAirportcode.length
                      ? ' ' +
                        bookWidgetFields().airportsField.airports[i]
                          .fromAirportcode +
                        ', ' +
                        bookWidgetFields().airportsField.airports[i].fromCity
                      : ''),
                  swapArrow: bookWidgetAem().airportsField.swapAriaLabel,
                  departure:
                    bookWidgetAem().airportsField.departureAriaLabel +
                    (bookWidgetFields().airportsField.airports[i].toAirportcode
                      .length
                      ? ' ' +
                        bookWidgetFields().airportsField.airports[i]
                          .toAirportcode +
                        ', ' +
                        bookWidgetFields().airportsField.airports[i].toCity
                      : '')
                }
              }"
              [routePickerCities]="{
                destinationCode:
                  bookWidgetFields().airportsField.airports[i].toAirportcode,
                destinationName:
                  bookWidgetFields().airportsField.airports[i].toCity,
                destinationRegion: '',
                originCode:
                  bookWidgetFields().airportsField.airports[i].fromAirportcode,
                originName:
                  bookWidgetFields().airportsField.airports[i].fromCity,
                originRegion: ''
              }"
              [routePickerError]="
                bookWidgetFields().airportsField.fieldErrorInfo
                  ?.routePickerField
              "
              [recentSearchList]="recentSearchList()"
              [savedSearchList]="savedSearchList()"
              [searchModalTabs]="searchModalTabs()"
              [isFullscreen]="isFullscreen()"
              [predictiveSearchData]="predictiveSearchData()"
              (swapClicked)="swapClicked.emit(i)"
              (searchModalTriggerClicked)="
                searchModalTriggerClicked.emit($event)
              "
              (searchModalEvent)="searchModalEvent.emit($event)"
            ></idp-multicity-route-picker-mach-core>
            <idp-date-picker-mach-core
              class="w-[304px]"
              [selectedTripType]="
                bookWidgetFields().tripTypesField.selectedTripType
              "
              [selectedRange]="bookWidgetFields().datesField.dates[i]"
              [bookWidgetAem]="bookWidgetAem()"
              [datepickerConfig]="datepickerConfig()"
              [fieldErrorInfo]="
                bookWidgetFields().datesField.fieldErrorInfo?.[i]
              "
              (selectedDateRange)="
                onDateSelectionChange(
                  $event,
                  bookWidgetFieldUpdateTypes.datesChange,
                  i
                )
              "
            ></idp-date-picker-mach-core>
            <idp-connection-picker-mach-core
              class="laptop:w-[296px] ultrawide:w-[520px]"
              [routeIndex]="i"
              [placeholder]="bookWidgetAem().airportsField.connectionLabel"
              [connection]="{
                connectionCity: airportItem.connectionCity ?? '',
                connectionAirport: airportItem.connectionAirport ?? ''
              }"
              [recentSearchList]="recentSearchList()"
              [savedSearchList]="savedSearchList()"
              [searchModalTabs]="searchModalTabs()"
              [connectionError]="
                bookWidgetFields().airportsField.fieldErrorInfo
                  ?.connectionAirportField
              "
              [isFullscreen]="isFullscreen()"
              [predictiveSearchData]="predictiveSearchData()"
              [helpIconAriaLabel]="bookWidgetAem().helpIconAriaLabel"
              (searchModalTriggerClicked)="
                searchModalTriggerClicked.emit($event)
              "
              (searchModalEvent)="searchModalEvent.emit($event)"
              (showConnectionAirportInfoModal)="
                infoIconClickHandler(
                  bookWidgetFieldInfoTypes.CONNECTION_AIRPORT
                )
              "
              (clearConnectionAirport)="clearConnectionAirport(i)"
            ></idp-connection-picker-mach-core>
          </div>
        </div>
      }
    </div>
    <div class="flex flex-row justify-between">
      <div class="flex items-center">
        @if (bookWidgetFields().airportsField.showAddFlightBtn) {
          <a
            tabindex="0"
            class="link link-md"
            [attr.aria-label]="bookWidgetAem().airportsField.addFlight"
            (click)="addFlight.emit()"
            (keydown.enter)="addFlight.emit()"
          >
            <img
              src="/content/dam/delta-applications/sitewide/capability/flight-shop/images/plus.svg"
              alt=""
            />
            {{ bookWidgetAem().airportsField.addFlight }}
          </a>
        }
      </div>
      <div class="flex items-center">
        @if (bookWidgetFields().airportsField.showRemoveFlightBtn) {
          <a
            tabindex="0"
            class="link link-md"
            [attr.aria-label]="bookWidgetAem().airportsField.removeFlight"
            (click)="removeFlight.emit()"
            (keydown.enter)="removeFlight.emit()"
          >
            <img
              src="/content/dam/delta-applications/sitewide/capability/flight-shop/images/minus.svg"
              alt=""
            />
            {{ bookWidgetAem().airportsField.removeFlight }}
          </a>
        }
      </div>
    </div>
    <div class="flex flex-row justify-between">
      <div class="flex flex-row gap-32">
        @if (!bookWidgetFields().shopMilesField.hide) {
          <div class="flex items-center gap-12">
            <input
              #shopMilesCheckboxElement
              type="checkbox"
              id="shopMiles"
              class="checkbox"
              [disabled]="bookWidgetFields().shopMilesField.disable"
              [attr.aria-label]="bookWidgetAem().shopMilesField.shopWithMiles"
              [checked]="bookWidgetFields().shopMilesField.checked"
              (change)="
                onCheckBoxChange($event, bookWidgetFieldUpdateTypes.shopMiles);
                analyticsEvent.emit({ el: shopMilesCheckboxElement })
              "
            />
            <label
              for="shopMiles"
              class="text-static text-label-sm-medium mb-0 cursor-pointer"
              [ngClass]="{
                '!text-disabled !cursor-default':
                  bookWidgetFields().shopMilesField.disable
              }"
            >
              {{ bookWidgetAem().shopMilesField.shopWithMiles }}
            </label>
          </div>
        }
        @if (!bookWidgetFields().basicFaresField.hide) {
          <div class="flex items-center gap-12">
            <input
              #basicFaresCheckboxElement
              type="checkbox"
              id="basicFaresField"
              class="checkbox"
              [attr.aria-label]="bookWidgetAem().includeBasicField.includeBasic"
              [checked]="bookWidgetFields().basicFaresField.checked"
              [disabled]="bookWidgetFields().basicFaresField.disable"
              (change)="
                onCheckBoxChange($event, bookWidgetFieldUpdateTypes.basicFares);
                analyticsEvent.emit({ el: basicFaresCheckboxElement })
              "
            />
            <label
              for="basicFaresField"
              class="text-static text-label-sm-medium mb-0 cursor-pointer"
              [ngClass]="{
                '!text-disabled !cursor-default':
                  bookWidgetFields().basicFaresField.disable
              }"
            >
              {{ bookWidgetAem().includeBasicField.includeBasic }}
            </label>
          </div>
        }
        @if (!bookWidgetFields().refundableFareField.hide) {
          <div class="flex items-center gap-2 flex-row-reverse">
            <div class="w-[24px] h-[24px] p-[3px]">
              <img
                class="grayscale-effect"
                src="/content/dam/delta-applications/sitewide/capability/flight-shop/images/alert-icon-help.svg"
                [attr.aria-label]="
                  bookWidgetAem().refundableFareField.refundableOnly +
                  ' ' +
                  bookWidgetAem().helpIconAriaLabel
                "
                role="button"
                tabindex="0"
                (click)="
                  infoIconClickHandler(
                    bookWidgetFieldInfoTypes.REFUNDABLE_FARE_ONLY
                  )
                "
                (keydown.enter)="
                  infoIconClickHandler(
                    bookWidgetFieldInfoTypes.REFUNDABLE_FARE_ONLY
                  )
                "
              />
            </div>
            <div class="flex items-center gap-12">
              <input
                #refundableFaresCheckboxElement
                type="checkbox"
                id="refundableFares"
                class="checkbox"
                [disabled]="bookWidgetFields().refundableFareField.disable"
                [checked]="bookWidgetFields().refundableFareField.checked"
                [attr.aria-label]="
                  bookWidgetAem().refundableFareField.refundableOnly
                "
                (change)="
                  onCheckBoxChange(
                    $event,
                    bookWidgetFieldUpdateTypes.refundableFare
                  );
                  analyticsEvent.emit({ el: refundableFaresCheckboxElement })
                "
              />
              <label
                for="refundableFares"
                class="text-heading text-label-sm-medium mb-0 cursor-pointer"
                [ngClass]="{
                  '!text-disabled !cursor-default':
                    bookWidgetFields().refundableFareField.disable
                }"
              >
                {{ bookWidgetAem().refundableFareField.refundableOnly }}
              </label>
            </div>
          </div>
        }
      </div>
      <div>
        <a
          #advanceSearchLinkElement
          role="button"
          tabindex="0"
          class="link link-md"
          (click)="
            toggleAdvSearchExpandedEvent.emit();
            analyticsEvent.emit({ el: advanceSearchLinkElement })
          "
          (keydown.enter)="
            toggleAdvSearchExpandedEvent.emit();
            analyticsEvent.emit({ el: advanceSearchLinkElement, event: $event })
          "
        >
          <span class="link-sort-filter-icon"></span>
          {{ bookWidgetAem().advancedSearchBtn }}
          <span
            class="transition-transform duration-200 ease-out"
            [ngClass]="
              isAdvancedSearchExpanded()
                ? 'link-arrow-icon-expanded'
                : 'link-arrow-icon-collapsed'
            "
          ></span>
        </a>
      </div>
    </div>
    @if (isAdvancedSearchExpanded()) {
      <div class="flex flex-row justify-between gap-32">
        <div class="flex gap-12">
          @if (!bookWidgetFields().bestFareOptionsField.hide) {
            <div class="w-[279px]">
              <idp-best-fare-options-mach-core
                [title]="bookWidgetAem().bestFareOptionsField.bestFare"
                [disabled]="bookWidgetFields().bestFareOptionsField.disable"
                [infoModalContent]="
                  bookWidgetAem().bestFareOptionsField.infoModal
                "
                [dropdownOptions]="
                  bookWidgetFields().bestFareOptionsField.dropdownOptions
                "
                [infoTooltipOptions]="{
                  positions: 'bottom-left',
                  color: 'high-contrast',
                  triggerEvent: 'hover',
                  offset: 0
                }"
                (bestFareOptionsChange)="
                  onDropdownSelectionChange(
                    $event,
                    bookWidgetFieldUpdateTypes.bestFareOptions
                  )
                "
              ></idp-best-fare-options-mach-core>
            </div>
          }
          @if (!bookWidgetFields().meetingEventCodeField.hide) {
            <div class="w-[279px]">
              <idp-meeting-code-mach-core
                [placeholder]="
                  bookWidgetAem().meetingEventCodeField.placeholder
                "
                [title]="bookWidgetAem().meetingEventCodeField.meetingEventCode"
                [value]="
                  bookWidgetFields().meetingEventCodeField.meetingEventCodeValue
                "
                [disabled]="bookWidgetFields().meetingEventCodeField.disable"
                [infoModalContent]="
                  bookWidgetAem().meetingEventCodeField.infoModal
                "
                [errorMessage]="
                  bookWidgetFields().meetingEventCodeField.fieldErrorInfo
                    ?.errorMessage
                "
                [tooltipOptions]="{
                  positions: 'bottom-left',
                  color: 'high-contrast',
                  triggerEvent: 'hover'
                }"
                [disclaimerMessage]="
                  bookWidgetFields().meetingEventCodeField.disclaimerMessage
                "
                (valueChange)="
                  onInputFieldChange(
                    $event,
                    bookWidgetFieldUpdateTypes.meetingEventCode
                  )
                "
              ></idp-meeting-code-mach-core>
            </div>
          }
        </div>
        @if (!bookWidgetFields().edocsLink.hide) {
          <a
            #edocsLinkElement
            class="link link-md hover:border-none text-right"
            [ngClass]="{
              '!text-disabled pointer-events-none':
                bookWidgetFields().edocsLink.disable
            }"
            [href]="
              bookWidgetFields().edocsLink.disable
                ? null
                : bookWidgetFields().edocsLink.src
            "
            (click)="analyticsEvent.emit({ el: edocsLinkElement })"
          >
            {{ bookWidgetAem().edocsLink }}
          </a>
        }
      </div>
    }
  </div>
}
